import { constructionSafety, logisticsAsset, manufacturingSteel } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: '매장에 들어서자마자 특별 할인 혜택을 받거나, 제품 근처를 지나갈 때 휴대폰에 자동으로 제품 정보가 표시되는 이유를 궁금해한 적이 있나요? 그 답은 작지만 강력한 잠재력을 가진 기술, 바로 비콘(Beacon)에 있습니다. 이 글에서는 비콘이 무엇인지, 어떻게 작동하는지, 그리고 실제로 어떤 활용 사례가 있는지 알아보겠습니다. 우리 주변 세상과 상호작용하는 방식을 바꾸는 이 기술을 함께 살펴보겠습니다.',
  keywords: 'Beacon, 비콘, Bluetooth Beacon, BLE',
  ogSite: 'What is Beacon (비콘이란)? 디지털 시대의 혁신적인 위치 기술',
  title: 'What is Beacon (비콘이란)? 디지털 시대의 혁신적인 위치 기술',
  ogUrl: 'https://orbro.io/blog/what-is-beacon',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_GKJa22-s4n8cnB6njJpDfgnjfi39XioHLxc8cdikubcHgHvBQf3Q-NkG4StASjGn2l1SbpaChlUvB3hcadBEWUoHpothn-dnfy1-WU5hd8lzQqXLcyrtv5Wx276fsksJ8KVFGAUeaEWDMxzYB9tm-QamPTpPe1lBNVaIkKC0MvMS3lEr1qnYKYyflH0EjWFaukIV63Rd2CzfY0GDJWNUeMmnrU1LG6J3qGGpo8hM8hUrl0Wqb7AKbmlRw-ADQyDo7GgVEAUk1Mf4IJ2sTJJW9GXNRsK9BrkQo9xJ7lTvCq-mWhZe2zoA6qixIHSNVxS-iB0fEHB_wBPDzDB9huetwH-X8UCBBW8BeMIRARXsa6Zjt-rMgf4K0AZtXqtE1wHaGuUmIStAVbfwanaFkcaYdN0HwzoSte6rT6NPUWVuypaLwKEEP-1eYzAhVvOY2m14TRHP1wCYLRJ9bgDeQbWm6zjjYQzTrOJ7xaD-Q0nZ2hMjMfxY9FubHxrOsh9x1JswFcku8quthyplg_Bko4Jx9jf0-kgKirRX4XP34OpcWAECf6oE0MKWT3jOIa5sORv7Wjv84zgOSkFp9IXFDgEUdycBgVbzwENz9AmiyUun5nLAtHzUoCeeu2fUDfnRWjzWgKapUoHKUhAxTnIXq4X1Kn79r2c7vcRi7fpYd1AVIYWXslybz47JZ8rrc45yEeRjOHv3NOhTxNgp9Bvln_5nifvtUF-w2Ia4CbxhyYl7TKKCo4Wo38s45QRat1IcLsnSU-AeDfWJmqSG-ihVsKnJ9Cuut2532WkJ1Apy-9nedVRoY3AZCCHqoSzY5D5p4cW7d9NFBC-8pkcOYQ7IZo376auzQVv3gp_vlu52-DJ8ZEcTEEDEX-4OKXZ8OYIUVgWaDI-tdy2Rr79TcN8uTJWfyy-EYmfJoVX-sKciqthUgFj_Z1NLtyETAef_eCWfUxvxdlnZCfNI2YCJ815cnZmb3gcVQuFEDyERlBTva2T1y2-faq8bJqXJ7mg2lokvUeiJbRUrcaruujWUrc_YCBIaKVdCdsj8eNnPdv4GQ-JWnia98F33oBvhwLq5jyx1f0kX3Yv9tAb9jwWSFf7Lym26vMasH78R9hz_M4xM16jhM2jnRweEJq0AynbAYJN8ZhVMDWMtEZl-X9gn8dVtcC-VPplEpMTuTFZx3suPopPosprWRkhHVADeCawEFOPzFMdEeRzmL-iGGc6ulHq-yKEX3uZaOIHoPinYl9t64r-V2ETpQ6gH9C0FlZKlJxOKZ_20VNprgZS-UG066gqfDcgrK3yoEsBIVrEsi68Trh-JGAVnuubTq5iMM6uS8zDX2ULZNZLLQR5HfPAVa1k3R00pRI1MVmv7UQZ1gg13dXuYWiPA_DT2Qyl9Zjh0_Cl2L-mGXmyl2Zm1COCyRk4BYzvzcqpvnfdjKSzyKfrFUP0CVjzAEcoc4xF0RYnjP3pMPUBKgCD3yHmYBXSd6s2GGmz5A4e67Hwx2qIvQVI7AOdBpVpn1gq6MdJDhZD0pdYZd55Ppzi_6aQQkUgugm1nGNSRte_4V4HbIHcLosVCerMUS4Ocwx7ujPDvgxe-ZAR7DLG9V9EdaS1kRynDoKyM05s-2oO5wS8NYK7S0JLw=w1418-h1412?auditContext=prefetch',
  ogType: 'website',
  date: '2025-07-09',
  tag1: '#Beacon',
  tag2: '#비콘',
  tag3: '#BluetoothBeacon',
  tag4: '#BLE',
  text: [
    {
      head: '',
      subHead: '',
      desc: '자리에 앉기 위해 고민하거나, 들어갈 때 불을 켜야 하거나, 에어컨을 개인 취향에 맞게 조절해야 하는 일상을 상상해 본 적이 있나요? 이는 먼 미래의 일이 아니라 바로 스마트 오피스가 우리에게 제공하는 현실입니다. 이 글에서는 스마트 오피스가 무엇인지, 그 놀라운 이점, 그리고 기술이 우리의 업무 방식을 어떻게 변화시키고 있는지 설명하겠습니다. 함께 탐험 해보세요!',
      dot: ''
    },
    {
      head: '1. What is Beacon (비콘이란 무엇인가)?',
      subHead: '',
      desc: 'Beacon (비콘)은 블루투스 저에너지(BLE) 기술을 사용하는 소형 무선 장치로, 근처에 있는 스마트폰이나 태블릿과 같은 스마트 기기에 신호를 전송합니다. GPS는 야외에서 잘 작동하지만 실내에서는 제한적입니다. 반면, 비콘은 매장, 박물관, 공항과 같은 실내 공간에서 정확한 위치를 파악하도록 설계되었습니다. 무선 통신 기능을 통해 비콘은 기업이 고객과 스마트하고 개인화된 방식으로 연결할 수 있도록 돕습니다.\n간단히 말해, 비콘은 마치 \'디지털 등대\'와 같아서, 근처에 있는 사용자에게 정보를 제공하거나 경험을 활성화하는 신호를 발송합니다. 이는 소매, 여행, 공간 관리 등 현대 기술 트렌드에서 필수적인 부분입니다.\n예시: 패션 매장에 들어서면, 비콘이 즉시 할인 프로그램에 대한 알림을 휴대폰으로 보낼 수 있습니다.',
      dot: ''
    },
    {
      head: '2. Beacon (비콘)은 어떻게 작동할까?',
      subHead: '',
      desc: '비콘이 어떻게 작동하는지 이해하기 위해 기본적인 단계를 살펴봅시다.\n\n신호 발송: 비콘은 블루투스 저에너지(BLE)를 사용해 수 미터에서 수십 미터 범위 내에서 지속적으로 신호를 발송합니다. 범위는 설정에 따라 달라집니다.\n\n신호 수신: 호환되는 앱이 설치된 스마트폰이나 스마트 기기는 해당 범위 내에 들어오면 신호를 감지합니다.\n\n정보 처리: 앱은 신호를 해독하고, 알림 표시, 링크 열기, 데이터 기록 등 미리 프로그래밍된 작업을 수행합니다.\n\n상호작용: 사용자는 자신의 위치에 맞는 정보 또는 경험을 제공받습니다.\n\n비콘은 주로 애플이 개발한 iBeacon이나 구글이 개발한 Eddystone과 같은 프로토콜을 기반으로 하며, 대부분의 운영 체제와 호환됩니다. 각 비콘은 고유한 식10자(UUID)를 가지고 있어, 앱이 어떤 장치가 신호를 보내고 있는지 정확히 파악할 수 있습니다.\n\n예시: 쇼핑몰에서 비콘은 근처를 지나갈 때 찾고 있는 매장으로 가는 길을 안내하는 지도를 보낼 수 있습니다.',
      dot: ''
    },
    {
      head: '3. 주요 Beacon (비콘) 유형',
      subHead: '',
      desc: '현재 다양한 유형의 비콘이 있지만, 가장 널리 사용되는 두 가지 유형은 다음과 같습니다.',
      dot: ''
    },
    {
      head: '',
      subHead: 'iBeacon',
      desc: '특징: 애플이 도입한 것으로, iOS와 안드로이드 모두에서 잘 작동합니다.\n활용 사례: 소매, 이벤트, 실내 위치 파악에 자주 사용됩니다.\n예시: 카페에서 고객이 들어오면 iBeacon을 통해 할인 코드를 전송합니다.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Eddystone',
      desc: '특징: 구글이 개발한 것으로, URL을 직접 전송할 수 있으며, 여러 플랫폼과 호환됩니다.\n활용 사례: 내비게이션, 공공 서비스, 마케팅에 적합합니다.\n예시: 기차역에서 Eddystone을 사용해 승객의 휴대폰으로 열차 시간을 안내합니다.\n\n이 외에도 AltBeacon(오픈 소스)이나 GeoBeacon(지리적 위치 전문)과 같은 유형이 있지만, iBeacon과 Eddystone이 여전히 가장 널리 사용됩니다.',
      dot: ''
    },
    {
      head: '4. Beacon (비콘)의 실제 활용 사례',
      subHead: '',
      desc: '비콘은 단순한 기술이 아니라, 기업과 사용자가 상호작용하는 방식을 변화시키는 솔루션입니다. 다음은 몇 가지 주요 활용 사례입니다.\n\n• 소매 및 마케팅\n고객의 매장 내 위치에 따라 개인화된 할인 혜택을 전송합니다.\n예시: 슈퍼마켓에서 냉동 식품 코너 근처에 서 있을 때 할인 알림을 받습니다.\n\n• 실내 내비게이션\n쇼핑몰, 공항과 같은 대형 공간에서 길 찾기를 지원합니다.\n예시: 지도 앱이 비콘을 사용해 가장 가까운 매장이나 주차장으로 안내합니다.\n\n• 자산 관리\n창고 내 장비나 상품의 위치를 추적합니다.\n예시: 물류 회사가 비콘을 사용해 창고 내 팔레트의 위치를 관리합니다.\n\n• 교육 및 박물관\n방문자가 전시물 근처에 있을 때 자세한 정보를 제공합니다.\n예시: 박물관에서 비콘을 사용해 보고 있는 그림에 대한 오디오 설명을 전송합니다.\n\n• 이벤트 및 컨퍼런스\n참가자에게 일정이나 혜택에 대한 정보를 전송합니다.\n예시: 기술 컨퍼런스에서 비콘을 사용해 곧 시작될 워크숍에 대한 알림을 보냅니다.',
      dot: ''
    },
    {
      head: '5. Beacon (비콘) 사용의 이점',
      subHead: '',
      desc: '비콘은 기업과 사용자 모두에게 다양한 가치를 제공합니다.\n\n• 개인화된 경험: 각 고객에게 맞춤형 정보를 제공합니다.\n\n• 저렴한 비용: 소형 장치로 설치가 쉽고 에너지를 절약합니다.\n\n• 상호작용 증가: 고객이 쉽게 정보와 내비게이션을 받을 수 있습니다.\n\n• 데이터 수집: 고객 행동에 대한 인사이트를 제공하여 전략을 최적화합니다.\n\n예시: 한 매장 체인은 비콘을 사용해 적시에 할인 혜택을 제공함으로써 매출을 20% 증가시켰습니다.',
      dot: ''
    },
    {
      head: '6. Beacon (비콘)의 도전 과제와 전망',
      subHead: '',
      desc: '비콘은 많은 장점을 가지고 있지만, 몇 가지 도전 과제도 있습니다.\n\n• 프라이버시: 사용자가 추적되는 것에 대한 우려가 있을 수 있습니다.\n• 앱 의존성: 비콘 신호를 받으려면 앱을 설치해야 합니다.\n• 유지 관리: 여러 장치의 배터리를 교체하는 데 시간이 소요될 수 있습니다.\n\n그러나 비콘의 미래는 매우 발전할 수 있고 밝습니다.\n\n• IoT 통합: 사물인터넷(IoT) 생태계 내의 스마트 기기와 연결됩니다.\n• 다양한 활용: 의료, 교육, 스마트 시티 등으로 확장됩니다.\n• 향상된 보안: 암호화 기술이 데이터를 더 안전하게 보호할 것입니다.\n\n예시: 미래의 병원에서는 비콘을 사용해 환자가 진료실로 빠르게 이동할 수 있도록 안내할 수 있습니다.',
      dot: ''
    },
    {
      head: '7. 결론',
      subHead: '',
      desc: 'Beacon (비콘)은 물리적 세계와 디지털 세계를 매끄럽게 연결하는 혁신적인 위치 기술입니다. 고객 경험을 향상시키고, 관리를 최적화하며, 실내 공간에서 새로운 가능성을 열어주는 비콘은 우리의 생활과 업무 방식을 변화시키고 있습니다. 비즈니스를 성장시키고 싶거나 기술에 관심이 있는 분이라면, 오늘 바로 비콘을 탐구하고 적용해 보세요!',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
        img: productImg.product.workerTracking.key1,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/enterprise/logistics/asset',
      },
      {
        img: manufacturingSteel.thumb,
        data: 'manufacturingSteel',
        link: '/enterprise/manufacturing/steel',
      },
    ],
  },
};
